import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MapaCurricularService} from './_services/mapa-curricular.service';

@Component({
  selector: 'mapa-curricular-barra',
  standalone: false,
  templateUrl: 'mapa-curricular-barra.component.html'
})

export class MapaCurricularBarraComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private mapaCurricularService: MapaCurricularService) {
  }

  ngOnInit() {
  }
}
